import { OverlayTrigger, Tooltip, Col, Row, Grid } from "react-bootstrap";
import { compose, graphql } from "react-apollo";

import Button from "../../elements/CustomButton/CustomButton";
import CurrencySpan from "../Currency/CurrencySpan";
import { FormattedMessage } from "react-intl";
// import CurrencySpan from "../Currency/CurrencySpan";
import PropTypes from "prop-types";
import Queries from "../../queries/queries2";
import React from "react";
import Spinner from "../../elements/Spinner/Spinner";
import Table from "../../elements/Table/Table";
import _ from "lodash-es";
import { injectIntl } from "react-intl";
import { pure } from "recompose";
import { withRouter } from "react-router-dom";
import { Right } from "react-bootstrap/lib/Media";


// const data = graphql(Queries.GET_CLIENT_CONNECTION, {
//   options: ({ companyId }) => {
//     return {
//       fetchPolicy: "cache-and-network",
//       variables: {
//         skip: 0,
//         first: 1000,
//         companyId,
//         tiersId: "",
//         showYearBudget: true
//       }
//     };
//   }
// });

const data = graphql(Queries.getClientsForBudget, {
  options: ({ companyId }) => {
    return {
      fetchPolicy: "cache-and-network",
      variables: {
        skip: 0,
        first: 1000,
        companyId,
        tiersId: ""
      }
    };
  }
});

const BudgetClientList = ({
  deleteClients,
  // forceAutoLettrageTiers,
  history,
  // data: { clientTiersesConnection },
  data: { getClientsForBudget },
  loadMoreClients,
  onRowSelect,
  currency,
  tabSelected,
  currentYear,
  nextYear,
  intl,
  handleEditBudget,
  handleChangeBudgetProject,
  companyId,
  role,
  showBackupModal,
  getHistory,
  getHistory2,
  attributesArray,
  orderArray
}) => {
  // console.log("65 - BudgetClientList render");
  // if (data.loading || !clientTiersesConnection) {
  //   return <Spinner size="lg" fullScreen />;
  // }
  if (data.loading || !getClientsForBudget) {
    return <Spinner size="lg" fullScreen />;
  }

  // let { edges } = clientTiersesConnection;
  let { edges } = getClientsForBudget;

  // console.log("47 - edges", edges);

  let edgesFiltered = edges;
  if (tabSelected === "late") {
    edgesFiltered = _.filter(edges, o => {
      // console.log("o", o.node);
      return o.node.invoiceLateCount > 0;
    });
  }
  if (tabSelected === "due") {
    edgesFiltered = _.filter(edges, o => {
      // console.log("o", o.node);
      return o.node.invoiceDueCount > 0;
    });
  }

  let pivots = ["name"];
  let sortedEdges = [];
  if (edgesFiltered) {
    if (attributesArray)
      sortedEdges = _.orderBy(edgesFiltered, attributesArray, orderArray);
    else
      sortedEdges = _.orderBy(edgesFiltered, ["node.budgetCurrent"], ["desc"]);
  }

  const hideLinks = false;

  // const count = aggregate.count;
  const visibleColumns = [
    {
      id: "group",
      name: "group",
      type: "string",
      accessor: "node.group",
      maxWidth: 100,
      Aggregated: row => <div />
    },
    {
      id: "name",
      name: "name",
      type: "string",
      accessor: "node.name",
      maxWidth: 300,
      Cell: row => {
        // console.log("row piece", row);

        const value = row.value;

        if (!!!hideLinks) {
          const toolTip = (
            <Tooltip id="tooltip">
              <p>
                <FormattedMessage id="ids_goToClient" />
              </p>
            </Tooltip>
          );

          const icon = (
            <OverlayTrigger placement="top" overlay={toolTip}>
              <Button
                icon
                wd
                bsStyle="primary"
                style={{
                  minWidth: "inherit",
                  border: "none",
                  padding: "0px 0px 0px 0px",
                  margin: "-3px 1px 0px 0px",
                  borderRadius: "100%"
                }}
                onClick={e => {
                  e.stopPropagation();
                  // console.log("CLICK...", row);
                  let tiersId;
                  let str =
                    row &&
                    row.original &&
                    row.original.node &&
                    row.original.node.id;

                  if (str.substring(0, 5) === "fake_") {
                    str = str.substring(5, str.length);
                    tiersId = str.substring(0, str.indexOf("_"));
                  } else tiersId = str;

                  history.push(`/clients/${tiersId}/show`);
                }}
                className="text-primary fa-lg fa fa-user"
              // style={{ paddingRight: "20px" }}
              />
            </OverlayTrigger>
          );

          return (
            <div>
              {icon}
              {value}
            </div>
          );
        } else {
          return <div>{value}</div>;
        }
      }
    },
    // {
    //   name: "email",
    //   type: "string",
    //   email: true,
    //   accessor: "node.client.contacts[0].email",
    //   maxWidth: 240
    // },
    {
      id: "respComm",
      name: "respComm",
      type: "string",
      maxWidth: 220,
      // accessor: "node.client.collaboratorRespCom.tiers.name"
      accessor: d => {
        // console.log("109 - ", d.node);
        const respCommName =
          (d.node.client &&
            d.node.client.collaboratorRespCom &&
            d.node.client.collaboratorRespCom.tiers &&
            d.node.client.collaboratorRespCom.tiers.name) ||
          "";
        return respCommName;
      },
      Cell: row => {
        const value = row.value;

        const tiersId =
          (row &&
            row.original &&
            row.original.node &&
            row.original.node.client &&
            row.original.node.client.collaboratorRespCom &&
            row.original.node.client.collaboratorRespCom.tiers &&
            row.original.node.client.collaboratorRespCom.tiers.id) ||
          null;

        if (!!!hideLinks && !!tiersId && role === "ADMIN") {
          const toolTip = (
            <Tooltip id="tooltip">
              <p>
                <FormattedMessage id="ids_goToCollaborator" />
              </p>
            </Tooltip>
          );

          const icon = (
            <OverlayTrigger placement="top" overlay={toolTip}>
              <Button
                icon
                wd
                bsStyle="primary"
                style={{
                  minWidth: "inherit",
                  border: "none",
                  padding: "0px 0px 0px 0px",
                  margin: "-3px 1px 0px 0px",
                  borderRadius: "100%"
                }}
                onClick={e => {
                  e.stopPropagation();

                  if (!!tiersId) history.push(`/collaborators/${tiersId}/show`);
                }}
                className="text-primary fa-lg fa fa-user"
              // style={{ paddingRight: "20px" }}
              />
            </OverlayTrigger>
          );

          return (
            <div>
              {icon}
              {value}
            </div>
          );
        } else {
          return <div>{value}</div>;
        }
      },
      aggregate: vals => vals,
      Aggregated: row => <div>{row.isExpanded ? "" : row.value}</div>
    },


    {
      id: "project",
      name: `${intl.formatMessage({
        id: "project"
      })}`,
      type: "string",
      accessor: d => {
        return (
          (d.node &&
            d.node.budgetProject &&
            d.node.budgetProject.name &&
            d.node.budgetProject.name !== "N_A" &&
            d.node.budgetProject.name) ||
          ""
        );
      },
      Cell: row => {
        const value = row.value;
        const isBudget = (
          row && row.row && (
            row.row.budgetCurrent > 0 ||
            row.row.budgetNext > 0
          ));

        if (!!isBudget) {
          const toolTip = (
            <Tooltip id="tooltip">
              <p>
                <FormattedMessage id="ids_changeBudgetProject" />
              </p>
            </Tooltip>
          );

          const icon = (
            <OverlayTrigger placement="top" overlay={toolTip}>
              <div
                icon
                wd
                bsStyle="primary"
                style={{
                  minWidth: "inherit",
                  border: "none",
                  padding: "0px 0px 0px 0px",
                  margin: "0px 1px 0px 0px",
                  borderRadius: "100%",
                  textAlign: "right"
                }}

                onClick={e => {
                  e.stopPropagation();

                  let id = "";
                  if (row.original && row.original.node && row.original.node.id) {
                    let str = "" + row.original.node.id;
                    if (str.substring(0, 5) === "fake_") {
                      str = str.substring(5, str.length);
                      id = str.substring(0, str.indexOf("_"));
                    }
                    else
                      id = row.original.node.id;
                  }

                  console.log("324 - row.original.node=", row.original.node);
                  const node = {
                    ...row.original.node,
                    id: id,
                    selectedId: row.original.node.id
                  };
                  console.log("330 - node=", node);
                  handleChangeBudgetProject(node);
                }}
                className="fa fa-pencil text-primary pointer"
              />
            </OverlayTrigger>
          );

          return (
            <div>
              {/* <div className="space-between full-width"> */}
              {value}
              {icon}
              {/* </div>               */}
            </div>
          );
        } else {
          return <div>{value}</div>;
        }
      },
      maxWidth: 140,
      aggregate: vals => vals,
      Aggregated: row => <div>{row.isExpanded ? "" : row.value}</div>
    },


    {
      id: "budgetCurrent",
      noTranslateColumnName: true,
      name: `${intl.formatMessage({
        id: "ids_budget"
      })} ${currentYear}`,
      digit: 0,
      type: "currency",
      accessor: "node.budgetCurrent",
      maxWidth: 130,
      badges: args => {
        // console.log("onClickhandleEditBudget__", args, n2, n3);

        let classN = "fa fa-pencil text-primary pointer";

        if (args && args.node) {
          if (
            args &&
            args.node &&
            args.node.budgetCurrent === null &&
            args.node.budgetNext === null
          ) {
            classN = "fa fa-plus text-primary pointer";
          }

          if (
            args &&
            args.node &&
            args.node.budgetCurrent === 0 &&
            args.node.budgetNext === 0
          ) {
            classN = "fa fa-plus text-warning pointer";
          }
        }

        return (
          // <i
          //   onClick={() => {
          //     console.log("onClickhandleEditBudget", args);
          //     handleEditBudget(args && args.node);
          //   }}
          //   className="fa fa-pencil text-primary pointer"
          // />
          <i
            onClick={() => {
              // console.log("OnClick =", args);
              const node = {
                ...args.node,
                id: "",
                selectedId: args.node.id
              };
              if (args && args.node && args.node.id) {
                let str = "" + args.node.id;
                if (str.substring(0, 5) === "fake_") {
                  str = str.substring(5, str.length);
                  node.id = str.substring(0, str.indexOf("_"));
                } else node.id = args.node.id;

                // console.log("288 - onClickhandleEditBudget", node);
                handleEditBudget(node, sortedEdges);
              }
            }}
            // className="fa fa-pencil text-primary pointer"
            className={classN}
          />
        );
      },
      aggregate: vals => _.sum(vals),
      Aggregated: row => (
        <div
          style={{
            fontWeight: row.isExpanded ? "bold" : "Inherit",
            textAlign: row.isExpanded ? "left" : "Inherit"
          }}
        >
          <CurrencySpan digit={0} value={row.value} />
        </div>
      ),
      sortMethod: (a, b) => {
        a = (a === null || a === undefined || a === "") ? 0 : a;
        b = (b === null || b === undefined || b === "") ? 0 : b;
        if (a === b) {
          return 0;
        }
        const ret = a > b ? 1 : -1;
        return ret;
      }
    },
    {
      id: "budgetNext",
      noTranslateColumnName: true,
      name: `${intl.formatMessage({
        id: "ids_budget"
      })} ${nextYear}`,
      type: "currency",
      accessor: "node.budgetNext",
      digit: 0,
      maxWidth: 130,
      badges: args => {
        // console.log("onClickhandleEditBudget__", args, n2, n3);

        let classN = "fa fa-pencil text-primary pointer";

        if (args && args.node) {
          if (
            args &&
            args.node &&
            args.node.budgetCurrent === null &&
            args.node.budgetNext === null
          ) {
            classN = "fa fa-plus text-primary pointer";
          }

          if (
            args &&
            args.node &&
            args.node.budgetCurrent === 0 &&
            args.node.budgetNext === 0
          ) {
            classN = "fa fa-plus text-warning pointer";
          }
        }

        return (
          // <i
          //   onClick={() => {
          //     console.log("onClickhandleEditBudget", args);
          //     handleEditBudget(args && args.node);
          //   }}
          //   className="fa fa-pencil text-primary pointer"
          // />
          <i
            onClick={() => {
              console.log("409 - OnClick =", args);
              const node = {
                ...args.node,
                id: "",
                selectedId: args.node.id
              };
              if (args && args.node && args.node.id) {
                let str = "" + args.node.id;
                if (str.substring(0, 5) === "fake_") {
                  str = str.substring(5, str.length);
                  node.id = str.substring(0, str.indexOf("_"));
                } else node.id = args.node.id;

                // console.log("288 - onClickhandleEditBudget", node);
                handleEditBudget(node, sortedEdges);
              }
            }}
            // className="fa fa-pencil text-primary pointer"
            className={classN}
          />
        );
      },
      aggregate: vals => _.sum(vals),
      Aggregated: row => (
        <div
          style={{
            fontWeight: row.isExpanded ? "bold" : "Inherit",
            textAlign: row.isExpanded ? "left" : "Inherit"
          }}
        >
          <CurrencySpan digit={0} value={row.value} />
        </div>
      ),
      sortMethod: (a, b) => {
        a = (a === null || a === undefined || a === "") ? 0 : a;
        b = (b === null || b === undefined || b === "") ? 0 : b;
        if (a === b) {
          return 0;
        }
        const ret = a > b ? 1 : -1;
        return ret;
      }
    },
    {
      noTranslateColumnName: true,
      id: "budgetOrReal",
      name: "",
      // name: `${intl.formatMessage({
      //   id: "budgetOrReal"
      // })}`,
      type: "string",
      accessor: d => {
        if (d.node) {
          if (d.node.budgetIsReal === false) {
            return "B";
          }
        }
        return "";
      },
      maxWidth: 28,
      Aggregated: row => <div />
    }
    // {
    //   id: "respComm",
    //   name: "respComm",
    //   type: "string",
    //   maxWidth: 220,
    //   // accessor: "node.client.collaboratorRespCom.tiers.name"
    //   accessor: d => {
    //     console.log("109 - ", d.node);
    //     const respCommName = (d.node.client && d.node.client.collaboratorRespCom &&
    //       d.node.client.collaboratorRespCom.tiers && d.node.client.collaboratorRespCom.tiers.name) || "";
    //     return respCommName;
    //   },
    // }
    // {
    //   name: "tax1",
    //   type: "tax",
    //   maxWidth: 100,
    //   accessor: "node.client.defaultTax1.valuePourcent"
    // },
    // {
    //   name: "tax2",
    //   type: "tax",
    //   maxWidth: 100,
    //   accessor: "node.client.defaultTax2.valuePourcent",
    //   Footer: (
    //     <span
    //       style={{
    //         fontSize: "22px",
    //         marginRight: "0px"
    //       }}>
    //       <strong>Total</strong>{" "}
    //     </span>
    //   )
    // },
    // {
    //   name: "resteDu",
    //   type: "currency",
    //   accessor: "node.resteDu",
    //   noTextColor: true,
    //   maxWidth: 130,
    //   currency: currency,
    //   Footer: (
    //     <span style={{ fontSize: "22px", marginRight: "0px" }}>
    //       <CurrencySpan
    //         strong
    //         textColor={""}
    //         currencyId={currency && currency.id}
    //         value={_.round(_.sumBy(edgesFiltered, d => d.node.resteDu), 2)}
    //       />{" "}
    //     </span>
    //   )
    //   // Footer: (
    //   //   <span style={{ fontSize: "22px", marginRight: "5px" }}>
    //   //     {/* <strong>Total:</strong>{" "} */}
    //   //     {currency && (
    //   //       <CurrencySpan
    //   //         strong
    //   //         textColor={""}
    //   //         currencyId={currency.id}
    //   //         value={_.round(_.sumBy(edgesFiltered, d => d.node.resteDu))}
    //   //       />
    //   //     )}
    //   //   </span>
    //   // )
    // }
    // { name: "groupe", type: "string", accessor: 'node.groupe' },
  ];

  // console.log("READER", edgesFiltered);
  // console.log("READER(s)");

  // let idsGetHistoryBudgetClient = intl.formatMessage({
  //   id: "ids_getHistoryBudgetClient"
  // });
  // let idsCreateBudgetBackup = intl.formatMessage({
  //   id: "ids_createBudgetBackup"
  // });

  // let sortParams = [
  //   {
  //     id: "budgetCurrent",
  //     desc: true
  //   }
  // ];  

  return (
    <div>

      <Table
        // dock={role === "ADMIN" ? [
        //   <div>
        //     <Button
        //       title={idsCreateBudgetBackup}
        //       key="save"
        //       icon
        //       // fill
        //       // bsStyle="primary"
        //       pullRight
        //       onClick={showBackupModal}>
        //       <FormattedMessage id="ids_save" />
        //     </Button>

        //     <Button
        //       title={idsGetHistoryBudgetClient}
        //       key="history"
        //       icon
        //       // fill
        //       // bsStyle="primary"
        //       pullRight
        //       onClick={getHistory}>
        //       <FormattedMessage id="ids_historyBudgetClient" />
        //     </Button>
        //   </div>
        // ] : []}
        tableName="client"
        visibleColumns={visibleColumns}
        data={edgesFiltered}
        // pivotBy={pivots}
        // onRowClick={args => {
        //   handleEditBudget(args);
        // }}
        // onRowClick={id => history.push(`/clients/${id}/show`)}
        onRowClick={(args, row, rowInfo) => {
          // console.log("678 - sortedEdges=", sortedEdges);

          const node = {
            ...rowInfo.original.node,
            id: "",
            selectedId: rowInfo.original.node.id
          };
          if (rowInfo && rowInfo.original && rowInfo.original.node && rowInfo.original.node.id) {
            let str = "" + rowInfo.original.node.id;
            if (str.substring(0, 5) === "fake_") {
              str = str.substring(5, str.length);
              node.id = str.substring(0, str.indexOf("_"));
            } else node.id = rowInfo.original.node.id;
            handleEditBudget(node, sortedEdges);
          }
        }}
        onResize={(args) => {
          console.log("561 - args=", args);
        }}
        deleteRows={deleteClients}
        onRowSelect={onRowSelect}
        deletable
        printable
        exportable
        onGetHistory={role === "ADMIN" ? getHistory : undefined}
        onGetHistory2={role === "ADMIN" ? getHistory2 : undefined}
        onCreateBudgetBackup={role === "ADMIN" ? showBackupModal : undefined}
        // expandAll={true}
        defaultSorted={[
          {
            id: "budgetCurrent",
            desc: true
          },
          {
            id: "name",
            desc: false
          }
        ]}
        onSortedChange={(arg) => {

          attributesArray = new Array();
          orderArray = new Array();

          // var data = _.orderBy(array_of_objects, ['type','name'], ['asc', 'desc']);
          let addName = true;
          for (const element of arg) {
            attributesArray.push("node." + element.id);
            orderArray.push(element.desc ? "desc" : "asc");

            if (element.id === "name")
              addName = false;
          }
          sortedEdges = _.orderBy(edgesFiltered, attributesArray, orderArray);
        }}
      />
    </div>
  );
};

BudgetClientList.propTypes = {
  deleteClients: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired
};

export default compose(
  data,
  pure
)(injectIntl(withRouter(BudgetClientList)));
